type SearchConfigType = {
  siteId: string;
  siteUrl: string;
  context: string;
};

export const getSearchConfig = (): SearchConfigType => {
  return (
    SEARCH_CONFIG?.product || {
      siteId: 'materialbank_product',
      siteUrl: 'https://search.materialbank.com/v2',
      context: 'catalog',
    }
  );
};
